var _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3333,
    cy: 13.3333,
    r: 13.75,
    transform: "matrix(-1 0 0 1 27.9998 1.3335)",
    fill: "#6418C3",
    stroke: "white",
    strokeWidth: 0.833333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41635 11.9617C8.41635 11.3107 8.86848 10.7471 9.50395 10.6059L11.3025 10.2062C11.4571 10.1718 11.5953 10.0857 11.6942 9.96208L12.5132 8.93825C12.7768 8.60878 13.1759 8.41699 13.5978 8.41699H15.7349C16.1568 8.41699 16.5559 8.60878 16.8195 8.93825L17.6385 9.96208C17.7374 10.0857 17.8756 10.1718 18.0302 10.2062L19.8288 10.6059C20.4642 10.7471 20.9164 11.3107 20.9164 11.9617V18.8337C20.9164 19.6007 20.2945 20.2225 19.5275 20.2225H9.80524C9.03818 20.2225 8.41635 19.6007 8.41635 18.8337V11.9617Z",
    stroke: "white",
    strokeWidth: 1.38889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6662,
    cy: 15.0141,
    r: 2.77778,
    stroke: "white",
    strokeWidth: 1.38889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.0e50ac809d4cbee89c7e2f9691034fb0.svg";
export { ForwardRef as ReactComponent };